import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import librarySelector from "ulysses/features/library_selector.html";
import fileSelector from "ulysses/features/file_selector.html";
import HalResource from "ulysses/api";
import "ulysses/widgets";



function LibFolder(data) {
    this.full_path = ko.observable(data.full_path);
    this.name = ko.observable(data.name);
    this.children = ko.observableArray(data.children);
    this.files = ko.observableArray(data.files);
    this.parent = ko.observable(data.parent);
    this.icon = ko.observable(data.icon);
    this.id = ko.observable(data.id);
    this.complete_path = ko.observableArray(data.complete_path);
}

function LibViewModelMove(data, source) {
    var source = source;
    var self = this;
    this.root = new LibFolder(data);

    this.new_folder = function() {
        var folder = ko.utils.unwrapObservable(self.current_folder);
        var folder_id = ko.utils.unwrapObservable(folder.id);

        uly.api.start()
            .follow("uly:libraryfolder")
            .follow("move", {id:folder_id, sourceid: source.id, sourcetype: source.sourcetype})
            .then(function(result){
                var newfolder_resource = this;
                uly.dialogs.execute(
                    "<div class='form-group'><label>"+
                        _("library_dialog_new_folder_folder_name","Folder Name")+
                        "</label><input type='text' name='foldername' data-bind='value:foldername' class='form-control' /></div>",
                    {
                        title: _("library_dialog_new_folder_title","Create Folder"),
                        keyboard: true,
                        buttons:
                    {
                        "cancel": _("library_dialog_new_folder_btn_cancel","Back"),
                        "ok": _("library_dialog_new_folder_btn_ok","Create")
                    },
                    },
                    {
                        "foldername": _("library_dialog_new_folder_default_name","New Folder")
                    }
                ).done(function(result) {
                    uly.api.start().follow("uly:libraryfolder")
                        .follow("move", {id:folder_id, sourceid: source.id, sourcetype: source.sourcetype})
                        .post(null, {"foldername": ko.unwrap(result.foldername)})
                        .done(function(result) {
                            //posted...
                            uly.utils.show_results(result);
                            self.navigate_to(result.result);
                        })
                        .fail(function(error) {
                            uly.utils.show_results(error);
                        });

                });
                return false;
            });
    };

    this.navigate = function(folder) {
        uly.api.start()
            .follow("uly:libraryfolder")
            .follow("move", {id:folder.id, sourceid: source.id, sourcetype: source.sourcetype})
            .then(function(result) {
                self.current_folder(new LibFolder(result));
            });
        return false;
    };

    this.navigate_to = function(folder_id) {
        var id = folder_id;
        if( Object.prototype.toString.call( id ) === "[object Array]" ) {
            id = folder_id[1];
        }
        uly.api.start()
            .follow("uly:libraryfolder")
            .follow("move", {id:id, sourceid: source.id, sourcetype: source.sourcetype})
            .then(function(result) {
                self.current_folder(new LibFolder(result));
            });
        return false;
    };

    this.navigate_up = function(folder) {
        var parent = ko.utils.unwrapObservable(folder.parent);
        uly.api.start()
            .follow("uly:libraryfolder")
            .follow("move", {id:parent.id, sourceid: source.id, sourcetype: source.sourcetype})
            .then(function(result) {
                self.current_folder(new LibFolder(result));
            });
        return false;
    };
    this.current_folder = ko.observable(this.root);
}

function LibViewModel(data) {
    var self = this;
    this.root = new LibFolder(data);

    this.delete_file = function(file) {
        var file_to_delete = file;
        var cur_folder = ko.utils.unwrapObservable(self.current_folder);
        var folder_id = ko.utils.unwrapObservable(cur_folder.id);

        uly.api.start()
            .follow("uly:media")
            .follow("find", {id:file_to_delete.id})
            .then(function(result){
                var newfolder_resource = this;
                uly.dialogs.execute(
                    "<div class=\"alert alert-danger\" role=\"alert\">" +
                _("library_delete_file_confirm", "Are you sure you want to delete {0}").format(
                    file_to_delete.filename) +
                "</div>",
                    {
                        title: _("library_delete_file_delete_title", "Delete Folder"),
                        keyboard: false,
                        buttons:
                    {
                        "cancel": _("library_delete_file_btn_cancel", "Back"),
                        "ok": _("library_delete_ffile_btn_ok","Delete")
                    }
                    },
                    {
                    }
                ).done(function([result]) {
                    uly.api.start().follow("uly:media")
                        .follow("find", {id:file_to_delete.id})
                        .delete(null, {})
                        .done(function(result) {
                            //deleted...
                            uly.utils.show_results(result);
                            self.navigate_to(folder_id);
                        })
                        .fail(function(error) {
                            uly.utils.show_results(error);
                        });

                });
                return false;
            });
    };

    this.move_file = function(file) {
        var file_to_move = file;
        var cur_folder = ko.utils.unwrapObservable(self.current_folder);
        var folder_id = ko.utils.unwrapObservable(cur_folder.id);


        uly.api.start()
            .follow("uly:media")
            .follow("move", {id:file_to_move.id, sourceid:file_to_move.id})
            .then(function(result){
                var newfolder_resource = this;
                uly.dialogs.execute(
                    librarySelector,
                    {
                        title: _("library_dialog_move_file_title", "Move File {0} to ...").format(file_to_move.filename),
                        keyboard: true,
                        buttons:
                    {
                        "cancel": _("library_move_file_btn_cancel","Back"),
                        "ok": _("library_move_file_btn_ok","Move")
                    },
                        raw_data: true,
                    },
                    {
                        "foldername": ko.observable(null),
                        "folderid": ko.observable(null),
                        "id": file_to_move.id,
                        "name": file_to_move.filename,
                        "parent": file_to_move.parent,
                        "type": "media"
                    })
                    .done(function([result]) {
                        uly.api.start()
                            .follow("uly:media")
                            .follow("move", {id:file_to_move.id, sourceid:file_to_move.id})
                            .put(
                                null, {
                                    "action": "move",
                                    "file_to_move_name": result.filename,
                                    "file_to_move_id": result.id,
                                    "dest_foldername": result.foldername,
                                    "dest_folderid": result.folderid,
                                })

                            .done(function(result) {
                                //posted...
                                uly.utils.show_results(result);
                                self.navigate_to(folder_id);
                            })
                            .fail(function(error) {
                                uly.utils.show_results(error);
                            });

                    });
                return false;
            });
    };

    this.rename_file = function(folder) {
        var file_to_rename = folder;
        var cur_folder = ko.utils.unwrapObservable(self.current_folder);
        var folder_id = ko.utils.unwrapObservable(cur_folder.id);

        uly.api.start()
            .follow("uly:media")
            .follow("find", {id:file_to_rename.id})
            .then(function(result){
                var newfolder_resource = this;
                uly.dialogs.execute(
                    "<div class='form-group'><label>"+
                    _("library_rename_file_input_folder_name","Folder Name") + 
                    "</label><input type='text' name='foldername' data-bind='value:filename' class='form-control' /></div>",
                    {
                        title: _("library_rename_file_dialog_title", "Rename File"),
                        keyboard: true,
                        buttons:
                    {
                        "cancel": _("library_rename_file_btn_cancel", "Back"),
                        "ok": _("library_rename_file_btn_ok", "Rename")
                    }
                    },
                    {
                        "filename": file_to_rename.filename
                    }
                ).done(function([result]) {
                    uly.api.start().follow("uly:media")
                        .follow("find", {id:file_to_rename.id})
                        .put(null, {
                            "action": "rename",
                            "filename": ko.unwrap(result.filename)})
                        .done(function(result) {
                            //posted...
                            uly.utils.show_results(result);
                            self.navigate_to(folder_id);
                        })
                        .fail(function(error) {
                            uly.utils.show_results(error);
                        });

                });
                return false;
            });
    };

    this.delete = function(folder) {
        var folder_to_delete = folder;
        var cur_folder = ko.utils.unwrapObservable(self.current_folder);
        var folder_id = ko.utils.unwrapObservable(cur_folder.id);

        uly.api.start()
            .follow("uly:libraryfolder")
            .follow("find", {id:folder_to_delete.id})
            .then(function(result){
                var newfolder_resource = this;
                uly.dialogs.execute(
                    "<div class=\"alert alert-danger\" role=\"alert\">" +
                _("library_delete_folder_confirm", "Are you sure you want to delete {0}").format(
                    ko.utils.unwrapObservable(folder_to_delete.name)) +
                "</div>",
                    {
                        title: _("library_delete_folder_dialog_title", "Delete Folder"),
                        keyboard: false,
                        buttons:
                    {
                        "cancel": _("library_delete_folder_btn_cancel", "Back"),
                        "ok": _("library_delete_folder_btn_ok", "Delete")
                    }
                    },
                    {
                    }
                ).done(function([result]) {
                    uly.api.start().follow("uly:libraryfolder")
                        .follow("find", {id:folder_to_delete.id})
                        .delete(null, {})
                        .done(function(result) {
                            //deleted...
                            uly.utils.show_results(result);
                            self.navigate_to(folder_id);
                        })
                        .fail(function(error) {
                            uly.utils.show_results(error);
                        });

                });
                return false;
            });
    };

    this.move = function(folder) {
        var folder_to_move = folder;
        var cur_folder = ko.utils.unwrapObservable(self.current_folder);
        var folder_id = ko.utils.unwrapObservable(cur_folder.id);


        uly.api.start()
            .follow("uly:libraryfolder")
            .follow("move", {id:folder_to_move.id, sourceid:folder_to_move.id})
            .then(function(result){
                var newfolder_resource = this;
                uly.dialogs.execute(
                    librarySelector,
                    {
                        title: _("library_dialog_move_folder_title", "Move Folder {0} to ...").format(folder_to_move.name),
                        keyboard: true,
                        buttons:
                    {
                        "cancel": _("library_move_folder_btn_cancel", "Back"),
                        "ok": _("library_move_folder_btn_ok", "Move")
                    },
                        raw_data: true,
                    },
                    {
                        "foldername": ko.observable(null),
                        "folderid": ko.observable(null),
                        "id": ko.utils.unwrapObservable(folder_to_move.id),
                        "name": ko.utils.unwrapObservable(folder_to_move.name),
                        "parent": folder_to_move.parent,
                        "type": "library"
                    })
                    .done(function([result]) {
                        uly.api.start()
                            .follow("uly:libraryfolder")
                            .follow("move", {id:folder_to_move.id, sourceid:folder_to_move.id})
                            .put(
                                null, {
                                    "action": "move",
                                    "folder_to_move_name": result.name,
                                    "folder_to_move_id": result.id,
                                    "dest_foldername": result.foldername,
                                    "dest_folderid": result.folderid,
                                })

                            .done(function(result) {
                                //posted...
                                uly.utils.show_results(result);
                                self.navigate_to(folder_id);
                            })
                            .fail(function(error) {
                                uly.utils.show_results(error);
                            });

                    });
                return false;
            });
    };

    this.rename = function(folder) {
        var folder_to_rename = folder;
        var cur_folder = ko.utils.unwrapObservable(self.current_folder);
        var folder_id = ko.utils.unwrapObservable(cur_folder.id);

        uly.api.start()
            .follow("uly:libraryfolder")
            .follow("find", {id:folder_to_rename.id})
            .then(function(result){
                var newfolder_resource = this;
                uly.dialogs.execute(
                    "<div class='form-group'><label>" +
                    _("library_rename_folder_dialog_folder_name", "Folder Name") +
                    "</label><input type='text' name='foldername' data-bind='value:foldername' class='form-control' /></div>",
                    {
                        title: _("library_rename_folder_dialog_title", "Rename Folder"),
                        keyboard: true,
                        buttons:
                    {
                        "cancel": _("library_rename_folder_btn_cancel", "Back"),
                        "ok": _("library_rename_folder_btn_ok", "Rename")
                    }
                    },
                    {
                        "foldername": ko.utils.unwrapObservable(folder_to_rename.name)
                    }
                ).done(function([result]) {
                    uly.api.start().follow("uly:libraryfolder")
                        .follow("find", {id:folder_to_rename.id})
                        .put(null, {
                            "action": "rename",
                            "foldername": ko.unwrap(result.foldername)})
                        .done(function(result) {
                            //posted...
                            uly.utils.show_results(result);
                            self.navigate_to(folder_id);
                        })
                        .fail(function(error) {
                            uly.utils.show_results(error);
                        });

                });
                return false;
            });
    };

    this.new_folder = function() {
        var folder = ko.utils.unwrapObservable(self.current_folder);
        var folder_id = ko.utils.unwrapObservable(folder.id);

        uly.api.start()
            .follow("uly:libraryfolder")
            .follow("find", {id:folder_id})
            .then(function(result){
                var newfolder_resource = this;
                uly.dialogs.execute(
                    "<div class='form-group'><label>" + 
                    _("library_create_folder_input_folder_name", "Folder Name") +
                    "</label><input type='text' name='foldername' data-bind='value:foldername' class='form-control' /></div>",
                    {
                        title: _("library_create_folder_dialog_title", "Create Folder"),
                        keyboard: true,
                        buttons:
                    {
                        "cancel": _("library_create_folder_btn_cancel", "Back"),
                        "ok": _("library_create_folder_btn_ok", "Create")
                    },
                    },
                    {
                        "foldername": _("library_delete_folder_new_folder", "New Folder")
                    }
                ).done(function([result]) {
                    uly.api.start().follow("uly:libraryfolder")
                        .follow("find", {id:folder_id})
                        .post(null, {"foldername": ko.unwrap(result.foldername)})
                        .done(function(result) {
                            //posted...
                            uly.utils.show_results(result);
                            self.navigate_to(result.result);
                        })
                        .fail(function(error) {
                            uly.utils.show_results(error);
                        });

                });
                return false;
            });
    };

    this.navigate = function(folder) {
        uly.api.start()
            .follow("uly:libraryfolder")
            .follow("find", {id:folder.id})
            .then(function(result) {
                self.current_folder(new LibFolder(result));
            });
        return false;
    };

    this.navigate_to = function(folder_id) {
        var id = folder_id;
        if( Object.prototype.toString.call( id ) === "[object Array]" ) {
            id = folder_id[1];
        }
        uly.api.start()
            .follow("uly:libraryfolder")
            .follow("find", {id:id})
            .then(function(result) {
                self.current_folder(new LibFolder(result));
            });
        return false;
    };

    this.navigate_up = function(folder) {
        var parent = ko.utils.unwrapObservable(folder.parent);
        uly.api.start()
            .follow("uly:libraryfolder")
            .follow("find", {id:parent.id})
            .then(function(result) {
                self.current_folder(new LibFolder(result));
            });
        return false;
    };
    this.current_folder = ko.observable(this.root);

}

function LibSelectorViewModel(data, files, uploads_id) {
    this.root = new LibFolder(data);
    var self = this;


    this.new_folder = function() {
        var folder = ko.utils.unwrapObservable(self.current_folder);
        var folder_id = ko.utils.unwrapObservable(folder.id);

        uly.api.start()
            .follow("uly:libraryfolder")
            .follow("find", {id:folder_id})
            .then(function(result){
                var newfolder_resource = this;
                uly.dialogs.execute(
                    "<div class='form-group'><label>" +
                    _("library_selector_view_new_folder_folder_name", "Folder Name") +
                    "</label><input type='text' name='foldername' data-bind='value:foldername' class='form-control' /></div>",
                    {
                        title: _("library_selector_view_new_folder_dialog_title", "Create Folder"),
                        keyboard: true,
                        buttons:
                    {
                        "cancel": _("library_selector_view_new_folder_btn_cancel", "Back"),
                        "ok": _("library_selector_view_new_folder_btn_ok", "Create")
                    },
                    },
                    {
                        "foldername": _("library_selector_view_new_folder_default", "New Folder")
                    }
                ).done(function([result]) {
                    uly.api.start().follow("uly:libraryfolder")
                        .follow("find", {id:folder_id})
                        .post(null, {"foldername": ko.unwrap(result.foldername)})
                        .done(function(result) {
                            //posted...
                            uly.utils.show_results(result);
                            self.navigate_to(result.result);
                        })
                        .fail(function(error) {
                            uly.utils.show_results(error);
                        });

                });
                return false;
            });
    };

    this.navigate = function(folder) {
        uly.api.start()
            .follow("uly:libraryfolder")
            .follow("find", {id:folder.id})
            .then(function(result) {
                self.current_folder(new LibFolder(result));
            });
        return false;
    };

    this.navigate_to = function(folder_id) {
        var id = folder_id;
        if( Object.prototype.toString.call( id ) === "[object Array]" ) {
            id = folder_id[1];
        }
        uly.api.start()
            .follow("uly:libraryfolder")
            .follow("find", {id:id})
            .then(function(result) {
                self.current_folder(new LibFolder(result));
            });
        return false;
    };

    this.navigate_up = function(folder) {
        var parent = ko.utils.unwrapObservable(folder.parent);
        uly.api.start()
            .follow("uly:libraryfolder")
            .follow("find", {id:parent.id})
            .then(function(result) {
                self.current_folder(new LibFolder(result));
            });
        return false;
    };
    
    this.attachmedia = function(folder) {
        var folder_id = ko.unwrap(self.root.id)
        var folder_name = ko.unwrap(self.root.name)
        var folder_parent = ko.unwrap(self.root.parent)

    
        uly.api.start()
            .follow("uly:libraryfolder")
            .follow("find", {id:folder_id})
            .then(function(result){
                var newfolder_resource = this;
                uly.dialogs.execute(
                    fileSelector,
                    {
                        title: _("library_attach_media_dialog_title", "Choose file to attach"),
                        keyboard: true,
                        buttons:
                    {
                        "cancel": _("library_selector_view_attach_media_btn_cancel", "Back"),
                        "ok": _("library_selector_view_attach_media_btn_ok", "Ok")
                    },
                        raw_data: true,
                    },
                    {
                        "foldername": ko.observable(null),
                        "folderid": ko.observable(null),
                        "id": folder_id,
                        "name": folder_name,
                        "parent": folder_parent,
                        "type": "library",
                        "selectmedia": function(media, ev) {
                            uly.api.start()
                            .follow("uly:media")
                            .follow("attach", {id:media.id})
                            .post(null, {
                                "id":media.id,
                                "uploads_id": uploads_id,
                                "action":"attach"
                            })                    
                            .then(function(result){
                                $(ev.target).trigger("action:closedialog", { context: {$parent: {dialog_data:result.files }}});
                                // 
                            });
                        }

                    }).then(function([files_data]) {
                        $.each(files_data, function (idx, val) {
                            var upload = $.extend({}, val, {
                                "title": ko.observable(val.name || val.filename),
                                "mimetype": val.type,
                                "role_id": ko.observable(val.role_id),
                                "role": {
                                    "id": ko.observable(val.role? val.role.id : null),
                                    "name": ko.observable(val.role ? val.role.name : null)
                                }
                            });
                            files.push(upload);
                        });
                
                    })
            
                return false;
            });
    };

    this.current_folder = ko.observable(this.root);
    
}

ko.bindingHandlers.libraryselector = {
    init: function(elt, va, allbindings, model, context) {
        var library_ui = null;
        var folder = null;
        uly.api.start()
            .follow("uly:libraryfolder")
            .follow("move", {id:model.parent, sourceid: model.id, sourcetype: model.type})
            .then(function(result){
                library_ui = new LibViewModelMove(result, {id:model.id, name:model.name, sourcetype: model.type});
                library_ui.current_folder.subscribe( function(newvalue) {
                    allbindings().foldername(newvalue.name);
                    allbindings().folderid(newvalue.id);
                });
                var childContext = context.createChildContext(library_ui);
                ko.applyBindingsToDescendants(childContext, elt);
            });
        return { "controlsDescendantBindings": true};
        
    }
};

ko.bindingHandlers.sidelibrary = {

    init: function(elt, va, allbindings, model, context) {
        var library_ui = null;
        var folder = null;
        var url = "/api/v2/media";
        var element = $(elt);

        var init_upload_file = function (folder_id) {
            $(elt)
                .fileupload(
                    {
                        url: url,
                        dataType: "json",
                        autoUpload: true,
                        dropZone: $(elt),
                        pasteZone: $(elt),
                        uploadTemplateId: null,
                        downloadTemplateId: null,
                        fileInput: $("#__file_upload"),
                        replaceFileInput: true,

                        add: function (e, data) {
                            data.submit();
                            $("#__file_upload_progress").fadeIn();

                        },
                        fail: function (e, data) {
                            $("#__file_upload_progress").fadeOut();
                        },
                        drop: function (e, data) {
                            $("#__file_upload_progress").fadeIn();
                        },
                        done: function (e, data) {
                            $("#__file_upload_progress").fadeOut();
                        },
                        change: function(e, data) {
                        },
                        progressall: function (e, data) {
                            var progress = parseInt(data.loaded / data.total * 100, 10);
                            $("#__file_upload_progress > div").css(
                                "width",
                                progress + "%"
                            );
                        },
                        formData: function () {
                            var bound_entity = uly.utils.get_bound_entity($(elt));
                            var uid = null;
                            if (bound_entity) {
                                uid = ko.unwrap(bound_entity.unique_id);
                            }

                            var form_data = [
                                /* Remove that as that links the data to current entity
                            {
                                "name": "current_id",
                                "value": uid
                            },*/
                                {
                                    "name": "media_role",
                                    "value": ko.unwrap(allbindings().media_role)
                                }, {
                                    "name": "folder_id",
                                    "value": folder_id
                                }];
                            if (ko.unwrap(allbindings().extra_data)) {
                                $.each(ko.unwrap(allbindings().extra_data), function (key, value) {
                                    var val = ko.toJS(value);
                                    if (key && val) {
                                        form_data.push({
                                            "name": key,
                                            "value": val
                                        });
                                    }
                                    if (key == "note" && ko.isObservable(value))
                                        value(null);
                                });
                            }
                            return form_data;
                        },
                    }
                )
                .bind("drop dragover", function (e) {
                    e.preventDefault();
                });
        };

        uly.api.start()
            .follow("uly:libraryfolder")
            .follow("uly:root")
            .then(function(result){
                library_ui = new LibViewModel(result);
                library_ui.current_folder.subscribe( function(newvalue) {
                    setTimeout(function () {
                        init_upload_file(ko.unwrap(newvalue.id));
                    }, 1);
                });
                var childContext = context.createChildContext(library_ui);
                setTimeout(function () {

                    init_upload_file(ko.unwrap(ko.unwrap(library_ui.current_folder).id));
                }, 1);
                ko.applyBindingsToDescendants(childContext, elt);
            });

        return { "controlsDescendantBindings": true};
    },
};

ko.bindingHandlers.uploadfromlibrary = {
    "init": function (element, valueAccessor, bindings, viewModel, bindingContext) {
        var files = bindings().files;
        if (!files) files = ko.observableArray([]);
        var uploads_id = ko.utils.unwrapObservable(valueAccessor());
        var library_selector_ui = null;
        var folder = null;
        uly.api.start()
        .follow("uly:libraryfolder")
        .follow("uly:root")                    
        .then(function(result){
            library_selector_ui = new LibSelectorViewModel(result, files, uploads_id);
                var childContext = bindingContext.createChildContext(library_selector_ui);
                ko.applyBindingsToDescendants(childContext, element);
            });

        return {
            "controlsDescendantBindings": true
        };


    }
};
